import { Grid, TextField } from "@mui/material";
import { useState } from "react";
import * as React from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Notification from "../popup/Notification";
import ConfirmDialog from "../dialog/ConfirmDialog";
import Stack from "@mui/joy/Stack";
import Button from "@mui/joy/Button";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { LightTooltip } from "../tooltip/ToolTip";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import StringValidation from "../reusables/yupvalidation/StringValidation";

const AddTenant = (props) => {
  const { closeDialog, editTenant, selectedTenant } = props;

  var tenantInfo = null;
  var tenantId = "";
  var tenantNumber = "";
  var name = "";
  var email = "";
  var phone = "";

  var locations1 = null;
  var defaultLocation = null;
  var locationId = "";
  var specialities1 = null;
  var defaultSpeciality = null;
  var specialityId = "";

  var isSuspended1 = false;
  var isPhoneVerified = false;
  var isEmailVerified = false;
  var isAgreedToTerms = false;

  if (editTenant) {
    tenantInfo = JSON.parse(selectedTenant);
    tenantId = tenantInfo.id;
    tenantNumber = tenantInfo.tenantNumber;
    name = tenantInfo.name;
    email = tenantInfo.email;
    phone = tenantInfo.phone;

    locations1 = tenantInfo.locations;
    defaultLocation = locations1[0];
    specialities1 = tenantInfo.specialities;
    defaultSpeciality = specialities1[0];

    isSuspended1 = tenantInfo.suspended;
    isPhoneVerified = tenantInfo.phoneVerified;
    isEmailVerified = tenantInfo.emailVerified;
    isAgreedToTerms = tenantInfo.agreedToTerms;
  }

  const axiosPrivate = useAxiosPrivate();

  const resetForm = (props) => {
    // clear input fields
    var now = new Date();
    props.resetForm();
    setSelectedLocation("");
    setSelectedSpeciality("");
    setSelectedLocationKey(now);
    setSelectedSpecialityKey(now + "a");
    setIsSuspended(false);
  };

  const closeForm = (message) => {
    closeDialog(message);
  };

  // Suspended
  const sentenceCaseString = (bool) => {
    const str = bool.toString();
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const [isSuspended2, setIsSuspended] = useState(
    editTenant ? isSuspended1 : false
  );
  const [suspendedOptionsEmpty, setSuspendedOptionEmpty] = useState(false);
  const handleIsSuspendedOptionChange = (event, value) => {
    const suspendedValue =
      value === null
        ? false
        : value.label === suspendedOptions[0].label
        ? true
        : false;
    setIsSuspended(suspendedValue);
    setSuspendedOptionEmpty(false);
  };

  // Locations
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [locations, setLocations] = useState([]);
  const [locationLoading, setLocationLoading] = useState(
    locationsOpen && locations.length === 0
  );
  const [selectedLocation, setSelectedLocation] = useState(
    editTenant ? locationId : ""
  );
  const [selectedLocationKey, setSelectedLocationKey] = useState("locationKey");
  const [locationEmpty, setLocationEmpty] = useState(false);
  const LOCATIONS_URL = "api/v1/locations";
  const handleLocationChange = (event, value) => {
    setSelectedLocation(value.id);
    setLocationEmpty(false);
  };

  React.useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    if (!locationLoading) {
      return undefined;
    }

    const getLocations = async () => {
      try {
        const response = await axiosPrivate.get(LOCATIONS_URL, {
          signal: controller.signal,
        });
        isMounted && setLocations(response.data.data);
        setLocationLoading(false);
      } catch (error) {
        var errorMessage = "";
        if (error.response) {
          // The client was given an error response (5xx, 4xx)
          const errorData = error.response.data;
          errorMessage = errorData.message;
        } else if (error.request) {
          // The client never received a response, and the request was never left
          errorMessage = "No server response";
        } else {
          // Anything else
          errorMessage = "Unexpected error occurred";
        }
        console.log(errorMessage);
        setLocationLoading(false);
      }
    };

    getLocations();

    return () => {
      isMounted = false;
      controller.abort();
    };
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [locationLoading]);

  React.useEffect(() => {
    if (!locationsOpen) {
      setLocations([]);
    }
  }, [locationsOpen]);

  // Specialities
  const [specialitiesOpen, setSpecialitiesOpen] = useState(false);
  const [specialities, setSpecialities] = useState([]);
  const [specialityLoading, setSpecialityLoading] = useState(
    specialitiesOpen && specialities.length === 0
  );
  const [selectedSpeciality, setSelectedSpeciality] = useState(
    editTenant ? specialityId : ""
  );
  const [selectedSpecialityKey, setSelectedSpecialityKey] =
    useState("specialityKey");
  const [specialityEmpty, setSpecialityEmpty] = useState(false);
  const SPECIALITIES_URL = "api/v1/specialities";
  const handleSpecialityChange = (event, value) => {
    setSelectedSpeciality(value.id);
    setSpecialityEmpty(false);
  };

  React.useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    if (!specialityLoading) {
      return undefined;
    }

    const getSpecialities = async () => {
      try {
        const response = await axiosPrivate.get(SPECIALITIES_URL, {
          signal: controller.signal,
        });
        isMounted && setSpecialities(response.data.data);
        setSpecialityLoading(false);
      } catch (error) {
        var errorMessage = "";
        if (error.response) {
          // The client was given an error response (5xx, 4xx)
          const errorData = error.response.data;
          errorMessage = errorData.message;
        } else if (error.request) {
          // The client never received a response, and the request was never left
          errorMessage = "No server response";
        } else {
          // Anything else
          errorMessage = "Unexpected error occurred";
        }
        console.log(errorMessage);
        setSpecialityLoading(false);
      }
    };

    getSpecialities();

    return () => {
      isMounted = false;
      controller.abort();
    };
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [specialityLoading]);

  React.useEffect(() => {
    if (!specialitiesOpen) {
      setSpecialities([]);
    }
  }, [specialitiesOpen]);

  const validationSchema = Yup.object().shape({
    name: StringValidation(2, 40),
    phone: Yup.string()
      .required("Required")
      .matches(/^[0-9]\d{9}$/, {
        message: "Please enter valid phone number",
        excludeEmptyString: false,
      }),
    email: Yup.string().email("Please enter valid email").required("Required"),
    /* .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
        message: "Please enter valid email",
        excludeEmptyString: false,
      }) */
  });

  // Common
  const initialValues = editTenant
    ? {
        name: name,
        email: email,
        phone: phone,
        isSuspended: isSuspended2,
      }
    : {
        name: "",
        email: "",
        phone: "",
        locationId: "",
        specialityId: "",
      };

  function onSubmit(values, props) {
    // No location picked
    if (!editTenant && selectedLocation === "") {
      setLocationEmpty(true);
      props.setSubmitting(false);
      return;
    }

    // No speciality picked
    if (!editTenant && selectedSpeciality === "") {
      setSpecialityEmpty(true);
      props.setSubmitting(false);
      return;
    }

    if (editTenant && suspendedOptionsEmpty) {
      // Please select whether suspended
      setSuspendedOptionEmpty(true);
      props.setSubmitting(false);
      return;
    }

    props.setSubmitting(true);
    createTenant(values, props);
  }

  const TENANTS_URL = "/api/v1/tenants/";
  const createTenant = async (values, props) => {
    // Common
    const data = editTenant
      ? {
          tenantName: values.name,
          isSuspended: isSuspended2,
        }
      : {
          name: values.name,
          email: values.email,
          phone: values.phone,
          locationId: selectedLocation,
          specialityId: selectedSpeciality,
        };

    try {
      const response = editTenant
        ? await axiosPrivate.put(TENANTS_URL + tenantId, data, {
            headers: {
              "Content-Type": "application/json",
            },
          })
        : await axiosPrivate.post(TENANTS_URL + "save", data, {
            headers: {
              "Content-Type": "application/json",
            },
          });

      //console.log(response.data.message);
      props.setSubmitting(false);
      resetForm(props);
      closeForm(response.data.message);
    } catch (error) {
      props.setSubmitting(false);
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      const errorTitle = editTenant ? "Update" : "Create";
      setConfirmDialog({
        isOpen: true,
        title: `Failed To ${errorTitle} Tenant`,
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: { onSubmit },
      });
    }
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  return (
    <Grid>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <Stack spacing={2} mt={3} direction="column">
              <Field
                as={TextField}
                label="Name"
                name="name"
                placeholder="Enter name"
                fullWidth
                required
                helperText={
                  <ErrorMessage name="name">
                    {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                  </ErrorMessage>
                }
              />

              <Field
                as={TextField}
                label="Phone"
                name="phone"
                placeholder="Enter phone number"
                disabled={editTenant}
                fullWidth
                required
                helperText={
                  <ErrorMessage name="phone">
                    {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                  </ErrorMessage>
                }
              />

              <Field
                as={TextField}
                label="Email"
                name="email"
                placeholder="Enter email address"
                disabled={editTenant}
                fullWidth
                required
                helperText={
                  <ErrorMessage name="email">
                    {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                  </ErrorMessage>
                }
              />

              <Autocomplete
                id="location"
                fullWidth
                defaultValue={defaultLocation}
                onChange={handleLocationChange}
                disabled={editTenant}
                key={selectedLocationKey}
                open={locationsOpen}
                onOpen={() => {
                  setLocationLoading(true);
                  setLocationsOpen(true);
                }}
                onClose={() => {
                  setLocationLoading(false);
                  setLocationsOpen(false);
                }}
                isOptionEqualToValue={(location, value) =>
                  location.name === value.name
                }
                getOptionLabel={(location) =>
                  location.name ? location.name : ""
                }
                options={locations}
                loading={locationLoading}
                loadingText="Loading locations..."
                noOptionsText="No locations"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Location"
                    name="location"
                    error={locationEmpty}
                    helperText={locationEmpty ? "Location required" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {locationLoading ? (
                            <CircularProgress color="primary" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                id="speciality"
                fullWidth
                defaultValue={defaultSpeciality}
                onChange={handleSpecialityChange}
                disabled={editTenant}
                key={selectedSpecialityKey}
                open={specialitiesOpen}
                onOpen={() => {
                  setSpecialityLoading(true);
                  setSpecialitiesOpen(true);
                }}
                onClose={() => {
                  setSpecialityLoading(false);
                  setSpecialitiesOpen(false);
                }}
                isOptionEqualToValue={(speciality, value) =>
                  speciality.name === value.name
                }
                getOptionLabel={(speciality) =>
                  speciality.name ? speciality.name : ""
                }
                options={specialities}
                loading={specialityLoading}
                loadingText="Loading specialities..."
                noOptionsText="No specialities"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Speciality"
                    name="speciality"
                    error={specialityEmpty}
                    helperText={specialityEmpty ? "Speciality required" : ""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {specialityLoading ? (
                            <CircularProgress color="primary" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />

              {editTenant && (
                <Autocomplete
                  disablePortal
                  id="isSuspended"
                  defaultValue={sentenceCaseString(isSuspended1)}
                  onChange={handleIsSuspendedOptionChange}
                  //key={selectedSuspendedOptionKey}
                  fullWidth
                  options={suspendedOptions}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Is suspended"
                      placeholder="Is suspended"
                      error={suspendedOptionsEmpty}
                      helperText={
                        suspendedOptionsEmpty ? "Is suspended required" : ""
                      }
                    />
                  )}
                />
              )}
            </Stack>

            <Stack spacing={2} mt={3} direction="row" justifyContent="flex-end">
              <LightTooltip title="Clear form">
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: 8,
                    width: 120,
                    backgroundColor: "#808080",
                    padding: "7px 14px",
                    fontSize: "14px",
                    color: "white",
                    ":hover": {
                      bgcolor: "#696969",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    resetForm(props);
                  }}
                >
                  Reset
                </Button>
              </LightTooltip>

              <LightTooltip title="Submit details">
                <Button
                  loading={props.isSubmitting}
                  loadingPosition="start"
                  disabled={props.isSubmitting}
                  type="submit"
                  sx={{
                    width: 120,
                  }}
                  variant="solid"
                >
                  {props.isSubmitting ? "Submitting" : "Submit"}
                </Button>
              </LightTooltip>
            </Stack>
          </Form>
        )}
      </Formik>

      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </Grid>
  );
};

export default AddTenant;

const suspendedOptions = [{ label: "True" }, { label: "False" }];
